export class UserModel {
    isSuperAdmin = false;
    roleName!: string;
    roleId!: string;
    accessList: any[] = [];
    adminCompanyId!: number;
    idClaimCompany: string;
    officeLocation: string;
    constructor(public name = '', public emailAddress = '', public displayName = '', public workdayID = '') { }
  }

export interface RoleItem {
  roleId: string;
  roleName: string;
  roleDescription: string;
}

export const RoleDescriptionsList: RoleItem[] = [
  {
    roleId: "Admin",
    roleName: "Super Admin",
    roleDescription: "You are a super admin with full access to the entire application and the ability to manage all features and settings."
  },
  {
    roleId: "sayka-mfgapps-admin-role",
    roleName: "Super Admin",
    roleDescription: "You are a super admin with full access to the entire application and the ability to manage all features and settings."
  },
  {
    roleId: "companyadmin",
    roleName: "Company Admin",
    roleDescription: "You are a company admin with access to manage everything for your company in the application."
  },
  {
    roleId: "shopadmin",
    roleName: "Shop Admin",
    roleDescription: "You are a shop admin with access to manage everything for your shops in the application."
  },
  {
    roleId: "User",
    roleName: "User",
    roleDescription: "You have full access to the entries you create and view-only access to entries created by other users"
  },
  {
    roleId: "support-po",
    roleName: "Support Hub - Support Product Owner",
    roleDescription: "Triage and assign support-domain tickets to your Support Team. Close tickets as Duplicate or Other. Access to training, access, data, performance, integration, and user account tickets."
  },
  {
    roleId: "tech-po",
    roleName: "Support Hub - Tech Product Owner",
    roleDescription: "Triage and assign tech-domain tickets to your Dev Team. Close tickets as Duplicate or Other. Access to UI, functionality, features, bugs, performance, access permissions, integration, and workflow tickets."
  },
  {
    roleId: "support-team",
    roleName: "Support Hub - Support Team Member",
    roleDescription: "Work on support-domain tickets assigned to you. Update ticket status, request clarification, and send for validation. Assigned to Support Product Owner tickets only."
  },
  {
    roleId: "dev-team",
    roleName: "Support Hub - Dev Team Member",
    roleDescription: "Work on tech-domain tickets assigned to you. Update ticket status, request clarification, and send for validation. Assigned to Tech Product Owner tickets only."
  },
  {
    roleId: "support-user",
    roleName: "Support Hub - User",
    roleDescription: "Submit tickets and respond to clarification requests. Validate completed work during UAT/Validation phase."
  }
]